import { gql } from '@apollo/client';

export const DISTINCT_CAR_KEYS_QUERIES = gql`
  query distinctCarKeys($make: Boolean, $model: Boolean, $year: Boolean, $filters: [FilterParam!]) {
    distinctCarKeys(make: $make, model: $model, filters: $filters, year: $year) {
      year
      make
      model
    }
  }
`;
